export default "__VITE_ASSET__VH63zfEY__"